import { GameState } from "./game-state";
import { Ball } from "./ball";
import { HitResultEnum } from "../types/hit-result-enum";
import { Game } from "./game";
import { Vector2 } from "../math/vector2";
import { GameConfig } from "../config/game-config";
import { IAssetsConfig, IBallConfig } from "../types/game-config-type";
import gameApplication from "./game-app";
import { BallsFactory } from "./balls-factory";
import { store } from "../stores";
import { MutationType } from "../stores/mutation-types";

const sounds: IAssetsConfig = GameConfig.sounds;
const balls: IBallConfig = GameConfig.ball;
export class Game9Pool extends Game {

  private unknownIcon: string = "default.svg";
  private nineBall: Ball;

  private currentBall: number = 1;
	private breakShotFlag: boolean;
  private foulsCounter = new Array(2);
  
  constructor() {
    super();
    this.initGame();
  }

  /**
   * This initilises the game. 
   */
  public initGame(): void {
		this.foulsCounter[0] = 0;
		this.foulsCounter[1] = 0;

    this.rackBalls();

		this.currentBall = 1;
    this.breakShotFlag = true;
   
    // initilise the game state
    this.gameState = new GameState();
    this.gameState.setupCueBall = true;

    this.winGame = false;

    // start the game play
    this.startGame();
  }

  private rackBalls(): void {
    this.gameBalls = BallsFactory.createPool9Balls();
    this.cueBall = this.gameBalls[0];
    this.nineBall = this.gameBalls[9];
  }

  protected processEvents(): HitResultEnum {
    let result: HitResultEnum = HitResultEnum.OK;
    
    if (result == HitResultEnum.OK) {

      const firstHittedBall: Ball = this.gameState.firstCollidedBall;

      if (Object.keys(firstHittedBall).length === 0) {
        store.commit(MutationType.GAME_MESSAGE, `${this.currentTurnPlayer.playerId} hit no ball (foul).`);
        this.isFoul = true; // opponent can set cue ball position
        this.breakShotFlag = false;
        result = HitResultEnum.PLAYER_CHANGE;
      }
      else if (firstHittedBall.number != this.currentBall) {
        store.commit(MutationType.GAME_MESSAGE, `${this.currentTurnPlayer.playerId} hit wrong ball (foul).`);
        this.isFoul = true; // opponent can set cue ball position
        this.breakShotFlag = false;
        result = HitResultEnum.PLAYER_CHANGE;
      }
      else if (!this.cueBall.onTable) {
        store.commit(MutationType.GAME_MESSAGE, `Player ${this.currentTurnPlayer.playerId} scratched cue ball (foul).`);
        this.isFoul = true; // opponent can set cue ball position
        this.breakShotFlag = false;
        result = HitResultEnum.PLAYER_CHANGE;
      }
      else if (result == HitResultEnum.OK) {
        if (!this.gameState.ballBallCollision) {
          store.commit(MutationType.GAME_MESSAGE, `Player ${this.currentTurnPlayer.playerId} hit no ball (foul).`);
          this.isFoul = true; // opponent can set cue ball position
          this.breakShotFlag = false;
          result = HitResultEnum.PLAYER_CHANGE;
        }
        else if (result == HitResultEnum.OK) {
          if (this.gameState.pocketedBalls.length === 0) {
            result = HitResultEnum.PLAYER_CHANGE;
          
            if (!this.gameState.ballRailCollision) {
              this.isFoul = true; // opponent can set cue ball position	
              store.commit(MutationType.GAME_MESSAGE, `${this.currentTurnPlayer.playerId} had no ball contact with the rail after hitting the object ball (foul).`);
            }
          }
          else { // no balls were pocketed (excluding the cue ball)
            if (!this.nineBall.onTable) {
              if (this.breakShotFlag) {
                store.commit(MutationType.GAME_MESSAGE, `RESULT: 8 Ball ${this.currentTurnPlayer.playerId} wins the game - GOLDEN BREAK.`);
                result = HitResultEnum.WIN_GAME_GOLDEN_BREAK;
              }
              else {
                store.commit(MutationType.GAME_MESSAGE, `RESULT: ${this.currentTurnPlayer.playerId} wins the game.`);
                result = HitResultEnum.WIN_GAME;
              }
            }
          }
        }
      }
		}

		if (result !== HitResultEnum.WIN_GAME) {
			if (this.isFoul) {
				if (this.incrementFoul() === 3) {
					result = HitResultEnum.LOST_GAME_FOULS;
				}

				if (!this.nineBall.onTable) {
					this.respot9Ball();
				}
			}
			else { // no foul
        this.foulsCounter[this.currentPlayerIndex] = 0;
      }

      this.findCurrentBall();
      
      if (this.currentBall === 9) {
        // do nothing
      }
    }
    
    if (result == HitResultEnum.WIN_GAME || result == HitResultEnum.WIN_GAME_GOLDEN_BREAK) {
      this.winGame = true;
    }

		this.breakShotFlag = false;
		return result;
  }

  private findCurrentBall(): void {
		for (let i: number = 1; i <= 9; i++) {
			if (this.balls[i].onTable) {
				this.currentBall = i;
				break;
			}
		}
	}

  private incrementFoul(): number {
		let fc: number = this.foulsCounter[this.currentPlayerIndex];
		fc++;
		this.foulsCounter[this.currentPlayerIndex] = fc;
		if (fc == 2) {
			store.commit(MutationType.GAME_MESSAGE, `${this.currentTurnPlayer.playerId} fouls 2 consecutive times on 2 successive shots.`);
		} else if (fc == 3) {
			store.commit(MutationType.GAME_MESSAGE, `RESULT: Player ${this.currentTurnPlayer.playerId} loses to ${this.nextTurnPlayer.playerId} due to three consecutive fouls.`);
		}

		return fc;
  }
  
  private respot9Ball(): void {
    let position: Vector2 = new Vector2(GameConfig.nineBallPosition.x, GameConfig.nineBallPosition.y);

		if (!this.isValidPositionToPlaceBall(position)) {
      this.nineBall.show(this.findClosestPoint(position));
    } else {
      this.nineBall.show(position);
    }

    store.commit(MutationType.GAME_MESSAGE, `9 ball re-spotted after foul`);
  }

  /**
   * Validate the position of thr cue ball on the table.
   * 
   * @param position - the position of the cue ball
	 * @returns Retruns "true" if the cue ball postion is valid and "false" of not
   */
  public validateCueBallPosition(position: Vector2): boolean  {
		if (this.breakShotFlag) {
			if (position.x > Game.BAULK_LINE_POS) {
				return false;
			}
		}
		return true;
	}

  /**
   * This handles the change the of the current player if necessary.
   */
  public continueGame(): void {
    if (this.breakShotFlag &&
      this.currentTurnPlayer.player !== undefined &&
      this.hitResult === undefined) {
      this.currentTurnPlayer.player.ball = this.currentBall + '.svg'; // set player icon for the break shot
    }

    switch (this.hitResult) {
      case HitResultEnum.PLAYER_CHANGE:
        this.currentPlayerIndex = (this.currentPlayerIndex + 1) % this.players.length;

        this.currentTurnPlayer.player.playing = 'true';
        this.currentTurnPlayer.player.ball = this.currentBall + '.svg'; // set player icon

        this.nextTurnPlayer.player.playing = 'false';
        this.nextTurnPlayer.player.ball = this.unknownIcon; // set player icon

        // Store the player change in the Vues store.
        store.commit(
          MutationType.PLAY_TURN,
          this.players[this.currentPlayerIndex].playerId
        );

        // Emit the "player change" event to the Vue.js front end.
        gameApplication.fireEvent('PLAYER_CHANGE');

        break;

      case HitResultEnum.OK:
        this.currentTurnPlayer.player.playing = 'true';
        this.currentTurnPlayer.player.ball = this.currentBall + '.svg'; // set player icon

        this.nextTurnPlayer.player.playing = "false";
        this.nextTurnPlayer.player.ball = this.unknownIcon; // set player icon

        // Store the current player in the Vues store.
        store.commit(MutationType.PLAY_TURN, this.players[this.currentPlayerIndex].playerId);

        // Emit the "Okay" event to the Vue.js front end.
        gameApplication.fireEvent('OK');

        break;
    }

    // Store the players updated player details in the Vuex.
    // This this updates the status of the payers in the front end.
    store.commit(MutationType.PLAYER1, this.players[0]);
    store.commit(MutationType.PLAYER2, this.players[1]);
  }
}
